import React, { useEffect } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import reporteConsumoStore from "../../../../../lib/store/reporte_consumo_store";
import Select from 'react-select';
const FiltrosConsumos = () => {
    const {
        mostrarFiltros, editarMostrarFiltros,
        mensajesEmail, editarMensajesSelEmail,
        mensajesSms, editarMensajesSelSms,
        mensajesVoz, editarMensajesSelVoz,
        mensajesWhatsapp, editarMensajesSelWhatsapp,
        vehiculos, selVehiculos, editarSelVehiculos, contactos, selContactos, editarSelContactos, alertas, selAlertas, editarSelAlertas
    } = reporteConsumoStore();


    // 📌 Personalizar la vista del Select
    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: '34px',
            overflow: 'hidden'
        }),
        valueContainer: (provided) => ({
            ...provided,
            maxHeight: '34px',
            overflow: 'hidden'
        })
    };

    const aplicarFiltro = () => {
        editarMensajesSelEmail(obtenerListaFiltrada(mensajesEmail));
        editarMensajesSelSms(obtenerListaFiltrada(mensajesSms));
        editarMensajesSelVoz(obtenerListaFiltrada(mensajesVoz));
        editarMensajesSelWhatsapp(obtenerListaFiltrada(mensajesWhatsapp));
    };

    const obtenerListaFiltrada = (consumptions) => {
        if (consumptions !== null) {
            let filteredConsumptions = consumptions
                .filter(item =>
                    ((Array.isArray(selAlertas) ? selAlertas : []).length === 0 || selAlertas.some(f => f.value === item.idTipoAlerta)) &&
                    ((Array.isArray(selContactos) ? selContactos : []).length === 0 || selContactos.some(f => f.value === item.destinatarioId)) &&
                    ((Array.isArray(selVehiculos) ? selVehiculos : []).length === 0 || selVehiculos.some(f => f.value === item.idvehiculo))
                );
            return filteredConsumptions;
        } else {
            return consumptions;
        }
    };

    const limpiarFiltros = () => {
        editarSelAlertas([]);
        editarSelContactos([]);
        editarSelVehiculos([]);
        editarMensajesSelEmail(mensajesEmail);
        editarMensajesSelSms(mensajesSms);
        editarMensajesSelVoz(mensajesVoz);
        editarMensajesSelWhatsapp(mensajesWhatsapp);
    };

    const mostrarFiltroReporte = () => {
        editarMostrarFiltros(false);
    };

    // 📌 Método para manejar cualquier Select
    const handleSelectChange = (selected, options, setSelected) => {
        const allSelected = selected.some((option) => option.value === "all");
        const todasLasOpciones = options.flatMap((grupo) => grupo.options || grupo);
        if (allSelected) {
            if (selected.length === todasLasOpciones.length + 1) {
                setSelected([]);
            } else {
                setSelected(todasLasOpciones);
            }
        } else {
            setSelected(selected);
        }
    };

    return (
        !mostrarFiltros ? <></> :
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    width: '350px',
                    height: '100%',
                    backgroundColor: 'white',
                    zIndex: 1050,
                    padding: '1rem',
                    boxShadow: '2px 0 10px rgba(0,0,0,0.5)',
                }}
            >
                <Container fluid className="d-flex flex-column h-100 m-0 p-0">

                    <Row className="flex-grow-1 overflow-auto">
                        <Col>
                            <Row>
                                <Col md={12}>
                                    <Form.Group title={selAlertas.map(item => item.label)}>
                                        <Form.Label>Alertas</Form.Label>
                                        <Select className="mx-0 mb-3"
                                            key={'vehiculof-selector'}
                                            closeMenuOnSelect={false}
                                            options={[
                                                ...(selAlertas.length !== alertas.length
                                                    ? [{ value: "all", label: "Seleccionar todas" }]
                                                    : [{ value: "all", label: "Deseleccionar todas" }]),
                                                ...alertas,
                                            ]}
                                            classNamePrefix="react-select"
                                            placeholder='Seleccionar...'
                                            value={selAlertas}
                                            onChange={(selected) =>
                                                handleSelectChange(
                                                    selected,
                                                    alertas,
                                                    editarSelAlertas
                                                )
                                            }
                                            isMulti
                                            styles={customStyles}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group title={selContactos.map(item => item.label)}>
                                        <Form.Label>Contactos</Form.Label>
                                        <Select className="mx-0 mb-3"
                                            key={'vehiculof-selector'}
                                            closeMenuOnSelect={false}
                                            options={[
                                                ...(selContactos.length !== contactos.length
                                                    ? [{ value: "all", label: "Seleccionar todas" }]
                                                    : [{ value: "all", label: "Deseleccionar todas" }]),
                                                ...contactos,
                                            ]}
                                            classNamePrefix="react-select"
                                            placeholder='Seleccionar...'
                                            value={selContactos}
                                            onChange={(selected) =>
                                                handleSelectChange(
                                                    selected,
                                                    contactos,
                                                    editarSelContactos
                                                )
                                            }
                                            isMulti
                                            styles={customStyles}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group title={selVehiculos.map(item => item.label)}>
                                        <Form.Label>Vehículo</Form.Label>
                                        <Select className="mx-0 mb-3"
                                            key={'vehiculof-selector'}
                                            closeMenuOnSelect={false}
                                            options={[
                                                ...(selVehiculos.length !== vehiculos.length
                                                    ? [{ value: "all", label: "Seleccionar todas" }]
                                                    : [{ value: "all", label: "Deseleccionar todas" }]),
                                                ...vehiculos,
                                            ]}
                                            classNamePrefix="react-select"
                                            placeholder='Seleccionar...'
                                            value={selVehiculos}
                                            onChange={(selected) =>
                                                handleSelectChange(
                                                    selected,
                                                    vehiculos,
                                                    editarSelVehiculos
                                                )
                                            }
                                            isMulti
                                            styles={customStyles}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <div md={12}>
                                    <Button style={{ width: '120px' }} variant="primary" onClick={limpiarFiltros}>Limpiar</Button>
                                </div>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="mt-auto">
                        <Col className="align-content-end">
                            <hr style={{ width: '100%', height: '1px' }} />
                            <Row>
                                <div className="d-flex justify-content-between">
                                    <Button style={{ width: '120px' }} variant="primary" onClick={mostrarFiltroReporte}>Cerrar</Button>
                                    <Button style={{ width: '120px' }} variant="primary" onClick={aplicarFiltro}> Aplicar</Button>
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div >
    );
}

export default FiltrosConsumos;